import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { getReportDescription } from "../../store/helpers";
import {
  getRenderConfigSummaryItems,
  normalizeRenderConfig,
} from "../../store/renderConfig";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import DailyTableOnlyReport from "./DailyTableOnlyReport";

const DailyGeneratedReportPage = ({
  children,
  columnDefinitions,
  descriptionKey,
  normalizeData = (data) => data,
  title,
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const reportTypeId = useSelector(defaultSelectors.selectReportTypeId);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const config = normalizeRenderConfig(renderConfig, { columnDefinitions });
  const presentationSummaryItems = getRenderConfigSummaryItems(config, { columnDefinitions });
  const data = normalizeData(reportsData.data);

  return (
    <Box>
      <Box mb="20px">
        <h1>{title}</h1>
        <p>{getReportDescription(reportRange)[descriptionKey]}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <span className="reportPresentationSummaryLabel">Presentation</span>
            <span className="reportPresentationSummaryValue">
              {presentationSummaryItems.join(" / ")}
            </span>
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        !config.charts.enabled ? (
          <DailyTableOnlyReport
            columnDefinitions={columnDefinitions}
            data={data}
            renderConfig={config}
            reportTypeId={reportTypeId}
          />
        ) : (
          children({ data, renderConfig: config })
        )
      ) : (
        <Box mt={10}>
          <p>No data available in this report</p>
        </Box>
      )}
    </Box>
  );
};

export default DailyGeneratedReportPage;
